import React from 'react'
import ReactDOM from 'react-dom'
import Login from './screens/Login.js'

ReactDOM.render(
  <React.StrictMode>
    <Login />
  </React.StrictMode>,
  document.getElementById('root')
);
